<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="pad-lr-15">
  <form name="form" (ngSubmit)="register()" #f="ngForm" novalidate>
    <div class="container-fluid">
      <div class="row no-pad mar-btm-30 ">
        <h2 class="col-md-3 mar-top-20 ">{{'Create New User' | translate}}</h2>
      </div>
      <div class="row no-pad mar-btm-100 ">
        <div class="form-group col-md-3 " [ngClass]="{ 'has-error': f.submitted && !firstName.valid }">
          <label for="firstName">{{'First Name' | translate}}
            <span class="required">*</span>
          </label>
          <input type="text" class="form-control" name="firstName" [(ngModel)]="model.firstName" #firstName="ngModel"
            required maxlength="36" />
          <div *ngIf="f.submitted && !firstName.valid" class="help-block">{{'First Name is Required' | translate}}</div>
        </div>
        <div class="form-group col-md-3" [ngClass]="{ 'has-error': f.submitted && !lastName.valid }">
          <label for="lastName">{{'LASTNAME' | translate}}
            <span class="required">*</span>
          </label>
          <input type="text" class="form-control" name="lastName" [(ngModel)]="model.lastName" #lastName="ngModel"
            required maxlength="36" />
          <div *ngIf="f.submitted && !lastName.valid" class="help-block">{{'Last Name is required' | translate}}</div>
        </div>
        <div class="form-group col-md-3" [ngClass]="{ 'has-error': f.submitted && !emailId.valid }">
          <label for="emailId">{{'EMAIL' | translate}}
            <span class="required">*</span>
          </label>
          <input type="email" class="form-control" name="email" [(ngModel)]="model.emailId" [pattern]="emailPattern"
            #emailId="ngModel" required />
          <div *ngIf="f.submitted && emailId.errors" class="help-block">
            <div *ngIf="emailId.errors.required">
              {{'Email Address is required' | translate}}
            </div>
            <div *ngIf="emailId.errors.pattern">
              {{'INVALID_EMAIL' | translate}}
            </div>
          </div>
        </div>
        <div class="form-group col-md-3">
          <label for="phone">{{'Phone Number' | translate}}</label>
          <input type="text" class="form-control" name="phonenumber" [(ngModel)]="model.phone" #phone="ngModel"
            [pattern]="phonePattern" maxlength="17" />
          <div *ngIf="f.submitted && phone.errors" class="help-block">
            <div *ngIf="phone.errors.pattern">
              {{'INVALID_PHONE' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---row closes here-->

    <div class="container-fluid mar-top-30">
      <div class="row no-pad mar-btm-30">
        <div class="form-group col-md-3" [ngClass]="{ 'has-error': f.submitted && !loginId.valid }">
          <label for="loginId">{{'Login Id' | translate}}
            <span class="required">*</span>
          </label>
          <input type="text" class="form-control" name="loginId" [(ngModel)]="model.loginId" #loginId="ngModel"
            (ngModelChange)="valuechange($event)" required />
          <div *ngIf="f.submitted && !loginId.valid" class="help-block">{{'Login Id is required' | translate}}</div>
          <div id="mytext" class="help-block"></div>
        </div>

        <div class="form-group col-md-3" [ngClass]="{ 'has-error': f.submitted && !companyName.valid }">
          <label for="companyName">{{'Company Name' | translate}}

            <span class="required">*</span>
          </label>
          <input type="text" class="form-control" name="companyName" [(ngModel)]="model.companyName" #companyName="ngModel"
            required />
          <div *ngIf="f.submitted && !companyName.valid" class="help-block">{{'Company Name is required' | translate}}</div>
        </div>


        <div class="form-group col-md-3">
          <label for="password">{{'PASSWORD' | translate}}
            <!--<span class="required">*</span>-->
          </label>
          <input disabled type="password" class="form-control" name="password" [(ngModel)]="model.password" [pattern]="unamePattern"
            #password="ngModel" />
        </div>

        <div class="form-group col-md-3">
          <label for="confirmPassword">{{'Confirm Password' | translate}}
            <!--<span class="required">*</span>-->
          </label>
          <input disabled type="password" class="form-control" name="confirmPassword" [(ngModel)]="model.confirmPassword"
            #confirmPassword="ngModel" />
        </div>


      </div>
      <!---row closes here-->
    </div>
    <!--container end -->

    <div class="container-fluid mar-top-30">
      <div class="row no-pad mar-btm-30">

        <div class="form-group col-md-3">
          <label for="status">{{'STATUS' | translate}}</label>
          <input type="text" class="form-control" name="status" [(ngModel)]="model.status" #status="ngModel" required
            placeholder="Active" disabled />
        </div>
        <div class="form-group col-md-3">
          <label for="userRoleMapping">{{'User Role Mapping' | translate}}

            <span class="required">*</span>
          </label>
          <ng-multiselect-dropdown  name="userrolemapping"  [settings]="settingsroles" [data]="packagingPropertyOptMultiSelect" [(ngModel)]="model.userrolemapping"(onSelect)="onRoleItemSelect($event)"
          (onDeSelect)="OnRoleItemDeSelect($event)" (onSelectAll)="onRoleSelectAll($event)" (onDeSelectAll)="onRoleDeSelectAll($event)"
          #userrolemapping="ngModel" required></ng-multiselect-dropdown>
       
          <!-- nedd to uncomment below div  after multi select change -->
          <div *ngIf="f.submitted && !userrolemapping.valid" class="help-block">{{'User Role Mapping is required' |
            translate }}</div>
        </div>
        <div class="form-group col-md-3" [hidden]="operationTypeDropdown">
            <label for="userRoleMapping">{{'Operations Type' | translate}}

                <span class="required">*</span>
              </label>
          <select class="form-control" required [(ngModel)]="operationType" name="operationType"
           placeholder="Select Operation Types" (change)="onOperationTypeSelect($event)">
            <option value="Select" selected>Select</option>
            <option *ngFor="let op of operationTypes" [value]="op.value">{{op.displayName}}</option>
          </select>
          <div *ngIf="f.submitted && this.opTypeRequired" class="help-block">{{'Operation type is required' |
              translate }}</div>
        </div> 

      </div>
      <div class="row pad-lr-15">
        <div class="form-group col-md-3">
        
        <div class="" [hidden]="multiselectDropdown && suppliercodeDropdown">
          <label for="suppliercode">Select Supplier Code
            <span class="required" *ngIf="operationType===operationTypes[0].value">*</span>
          </label>
          <ng-multiselect-dropdown [hidden]="multiselectDropdown && suppliercodeDropdown" [settings]="settingsSupplierCode" [(ngModel)]="model.suppliercode"
            name="suppliercode" [data]="suppCodeList" [(ngModel)]="model.suppliercode"  (onSelect)="onItemSelect($event)"
            (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
            #suppliercode="ngModel" *ngIf="suppCodeList" [required]='supplierCodeReqFlag'></ng-multiselect-dropdown>
            <div [hidden]="suppliercodeDropdown" *ngIf="f.submitted && supplierCodeReqFlag" class="help-block">Supplier code is required.</div>
        </div>
      </div>

        <div class="form-group col-md-3">
        <div *ngIf="suppCodeList" [hidden]="operationDropdown">
          <label for="lineNumbers">Select Next Process</label>
          <ng-multiselect-dropdown [hidden]="operationDropdown" [settings]="settingsoperation"  class="col-md-3" [(ngModel)]="model.lineNumbers" name="lineNumbers"
            [data]="lineCodeList" (onSelect)="onSingleSelectOperation($event)"
            (onDeSelect)="onDeSelectOperation($event)" (onSelectAll)="onSelectAllOperation($event)" (onDeSelectAll)="DeSelectAllOperation($event)"
            #lineNumbers="ngModel" *ngIf="lineCodeList && LineN" ng-required="npdprequired"></ng-multiselect-dropdown>
          
            <div [hidden]="operationDropdown" *ngIf="f.submitted &&  this.npdprequired" class="help-block">Next Process
            Code is Required. </div>
          
        </div>
        </div>
        <div class="form-group col-md-3">
        <div *ngIf="deliveryPointList" [hidden]="delPointSuppCodeDropdown">
          <label for="deliveryPoints">Select Delivery Point</label>
          <ng-multiselect-dropdown [hidden]="delPointSuppCodeDropdown"  [settings]="settingsDeliveryPoint" [(ngModel)]="deliveryPointlink" name="deliveryPoints"
            [data]="deliveryPointList" (onSelect)="onSingleSelectDeliveyPoint($event)"
            (onDeSelect)="onDeSelectDeliveryPoint($event)" (onSelectAll)="onSelectAllDeliveryPoint($event)" (onDeSelectAll)="onDeSelectAllDeliveryPoint($event)"
            #lineNumbers="ngModel" *ngIf="deliveryPointList && LineN" ng-required="npdprequired"></ng-multiselect-dropdown>
         <div [hidden]="operationDropdown" *ngIf="f.submitted && !model.lineNumbers " class="help-block">Next Process
            Code is Required. </div> 
        </div>
        </div>

      

        <div [ngClass]="{'col-md-3 no-pad': l4Selected == true}" *ngIf="l4Selected == true && SMQList">
          <ng-multiselect-dropdown [ngModelOptions]="{standalone: true}" [settings]="settingsSMQ" [(ngModel)]="model.SMQMod"
            name="SMQList" [data]="SMQList"  (onSelect)="onSingleSMQ($event)" (onDeSelect)="onDeSelectSMQ($event)"
            (onSelectAll)="onSelectAllSMQ($event)" (onDeSelectAll)="onDeSelectAllSMQ($event)">
            <!-- <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item> -->
          </ng-multiselect-dropdown>
        </div>

        <div [ngClass]="{'col-md-3 no-pad': l4Selected == true}" *ngIf="l4Selected == true && SMVSList">
          <ng-multiselect-dropdown [ngModelOptions]="{standalone: true}"  [settings]="settingsSMVS" [(ngModel)]="model.SMVSMod"
            name="SMVSList" [data]="SMVSList"  (onSelect)="onSingleSMVS($event)" (onDeSelect)="onDeSelectSMVS($event)"
            (onSelectAll)="onSelectAllSMVS($event)" (onDeSelectAll)="onDeSelectAllSMVS($event)">
            <!-- <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item> -->
          </ng-multiselect-dropdown>
        </div>

        <div [ngClass]="{'col-md-3 no-pad': l4Selected == true}" *ngIf="l4Selected == true && logisticsList">
          <ng-multiselect-dropdown [ngModelOptions]="{standalone: true}"  [settings]="settingsLogistics" [(ngModel)]="model.LogisticMod"
            name="LogisticsList" [data]="logisticsList"  (onSelect)="onSingleLogistic($event)"
            (onDeSelect)="onDeSelectLogistic($event)" (onSelectAll)="onSelectAllLogistic($event)" (onDeSelectAll)="onDeSelectAllLogistic($event)">
            <!-- <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item> -->
          </ng-multiselect-dropdown>
        </div>

        <div [ngClass]="{'col-md-3 no-pad': l4Selected == true}" *ngIf="l4Selected == true && operationsList">
          <ng-multiselect-dropdown [ngModelOptions]="{standalone: true}"  [settings]="settingsOperations" [(ngModel)]="model.operationMod"
            name="OperationsList" [data]="operationsList"  (onSelect)="onSingleOM($event)"
            (onDeSelect)="onDeSelecOM($event)" (onSelectAll)="onSelectAllOM($event)" (onDeSelectAll)="onDeSelectAllOM($event)">
            <!-- <c-item>
              <ng-template let-item="item">
                <label style="color: #333;min-width: 150px; margin-bottom: 0px;">{{item.itemName}} </label>
                <small style="margin-left: 36px;text-transform: capitalize;"> {{item.firstName}} {{item.lastName}}</small>
              </ng-template>
            </c-item> -->
          </ng-multiselect-dropdown>
        </div>

      </div>
    </div>
    <div class="container-fluid mar-top-30">
      <div class="row no-pad mar-btm-30" style=" margin-left: 2px;">


        
      </div>
    </div>

    <div class="row text-center">
      <div class="col-md-6 text-right pad-rgt-30">
        <button [disabled]="userIDTaken" type="submit" value="Register" class="btn btn-primary black">{{'SAVE' |
          translate}}</button>
      </div>
      <div class="col-md-6 text-left pad-lft-30">
        <a [routerLink]="['/um']" class="btn btn-primary black">{{'CANCEL' | translate}}</a>
      </div>
    </div>
  </form>
</div>